import { chineseToEnglish as chineseToEnglishFunc } from '@/utils/commonUtil'
import $store from '@/store'

// 中英文映射
const zhEnMap = new Map([
  ['项目', 'Project'], ['行次', 'Sequence'], ['本月发生金额', 'Amount for the Month'], ['本年累计金额', 'Accumulated Amount for the Year'],
  ['一、主营业务收入', 'Main Business Revenue'], ['减：营业成本', 'Less: Operating Costs'], ['营业税金及附加', 'Business Taxes and Surcharges'],
  ['其中：消费税', 'Including Consumption Taxes'], ['营业税', 'Business Tax'], ['城市维护建设税', 'Urban Maintenance and Construction Tax'],
  ['资源税', 'Resource Tax'], ['土地增值税', 'Land Appreciation Tax'], ['城镇土地使用税、房产税、车船税、印花税', 'Urban and Township Land Use Tax'],
  ['教育费附加、矿产资源补偿税、排污费', 'Education Surcharge'], ['二、主营业务利润', 'Main Business Profit'],
  ['加：其他业务利润', 'Add: Other Business Profit'], ['减：销售费用', 'Less: Sales Expenses'],
  ['其中：商品维修费', 'Including Commodity Repair Costs'], ['广告费和业务宣传费', 'Advertising and Business Promotion Expenses'],
  ['管理费用', 'Administrative Expenses'], ['其中：开办费', 'Including Start-up Expenses'], ['业务招待费', 'Business Entertainment Expenses'],
  ['研究费用', 'Research Expenses'], ['财务费用', 'Financial Expenses'], ['其中：利息费用（收入以“-”号填列）', 'Including Interest Expenses (record income with "-" sign)'],
  ['三、营业利润（亏损以“-”号填列）', 'Operating Profit (Operating Loss is Recorded with "-" Sign)'],
  ['加：营业外收入', 'Add: Non-operating Income'], ['其中：政府补助', 'Including Government Grants'],
  ['加：投资收益（损失以“-”号填列）', 'Add: Investment Earnings (Losses are Recorded with "-" Sign)'],
  ['减：营业外支出', 'Less: Non-operating Expenses'], ['其中：坏账损失', 'Including Bad Debt Losses'],
  ['无法收回的长期债券投资损失', 'Irrecoverable Long-term Bond Investment Losses'], ['无法收回的长期股权投资损失', 'Irrecoverable Long-term Equity Investment Losses'],
  ['自然灾害等不可抗力因素造成的损失', 'Losses Caused by Force Majeure such as Natural Disasters'],
  ['税收滞纳金', 'Late Payment of Taxes and Fines'], ['四、利润总额（亏损总额以“-”号填列）', 'Total Profits (Total Losses are Recorded with "-" Sign)'],
  ['减：所得税费用', 'Less: Income Tax Expenses'], ['五：净利润（净亏损以“-”号填列）', 'Net Profit (Net Losses are Recorded with "-" Sign)']
])

/**
 * 中文转英文
 * @param {Object} obj
 */
export function chineseToEnglish(obj) {
  if ($store.getters.language === 'zh') {
    return
  }
  chineseToEnglishFunc(obj, zhEnMap)
}
